import { observer } from 'mobx-react-lite';
import { useState } from 'react';

import { TextEditor } from '../TextEditor';
import { IssueCardStore } from '../../model/IssueCardStore';

import s from './CommentForm.module.scss';

type Props = {
  store: IssueCardStore;
};

const validate = (text: string) => (text.trim() ? null : 'Комментарий не может быть пустым');

/** Как в Яндекс Трекере: поле «Написать комментарий» над списком раскрывается в редактор */
const CommentForm: React.FC<Props> = observer(({ store }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!isOpen) {
    return (
      <button
        type="button"
        className={s.placeholder}
        disabled={store.isSaving}
        onClick={() => setIsOpen(true)}
      >
        Написать комментарий
      </button>
    );
  }

  return (
    <TextEditor
      multiline
      minRows={3}
      initialValue=""
      ariaLabel="Новый комментарий"
      placeholder="Разметка YFM: **жирный**, списки, ссылки"
      submitLabel="Отправить"
      validate={validate}
      onSave={(text) => store.addComment(text.trim())}
      onClose={() => setIsOpen(false)}
    />
  );
});

export { CommentForm };
